import React, { Component, Fragment } from 'react'
import Cookies from 'js-cookie'
import PropTypes from 'prop-types'
import cx from 'classnames'

import ButtonLink from '../Button/ButtonLink'
import Modal from '../../Modal'
import Input from '../Input'
import Heading4 from '../typography/Heading4'
import Paragraph from '../typography/Paragraph'
import Button from '../Button/Button'
import RDGateway from '../../../gateways/RDGateway'

const FIELDS = ['name', 'email', 'telephone', 'company', 'activeClients']

const ACTIVITY = {
    erpSalesChannel: 'Canal de Vendas de ERP',
    erpManufacturer: 'Fabricante de ERP',
    integrator: 'Integrador'
}

const CLIENTS = {
    zero: '0%',
    upToTwenty: 'Entre 1% e 20%',
    upToFifty: 'Entre 21% e 50%',
    upToEighty: 'Entre 51% e 80%',
    upToHundred: 'Entre 81% e 100%'
}

class PartnerContactModal extends Component {
    constructor(props) {
        super(props)

        this.rdGateway = new RDGateway()
        this.state = this.getInitialState()
    }

    getInitialState() {
        const initialObject = {
            showDemoModal: false,
            showDemoForm: false,
            company: '',
            name: '',
            email: '',
            telephone: '',
            activity: '',
            activeClients: '',
            clients: '',
        }
        FIELDS.forEach(campo => {
            initialObject[`${campo}Error`] = false
        })
        return initialObject
    }

    setDataByCookie() {
        this.setState({
            partnerId: Cookies.get('leaderPartnerId') || ''
        })
    }

    openDemoModal(e) {
        e.preventDefault()

        this.setState({
            showDemoModal: true,
            showDemoForm: true
        })
    }

    closeDemoModal() {
        this.setState({
            showDemoModal: false,
            showDemoForm: false
        })
    }

    handleChange(e) {
        var name = e.target.id,
            value = e.target.value

        if(name === 'telephone') {
            value = this.telephoneMask(value)
        }

        this.setState({
            [name]: value,
            [`${name}Error`]: false,
            [`${name}Typing`]: true
        })
    }

    handlerEnterpriseActivity(type) {
        this.setState({'activity': type})
    }

    getSelectedActivity(selected) {
        return this.state.activity === selected
            ? 'active'
            : ''
    }

    handlerClients(type) {
        this.setState({'clients': type})
    }

    getSelectedClients(selected) {
        return this.state.clients === selected
            ? 'active'
            : ''
    }

    validation() {
        const newState = {};
        const regexEmail = /^(([^<>()\[\]\\.,;:\s@']+(\.[^<>()\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        const regexName = /^(.|\s)*\S(.|\s)*/
        const regexTelephone = /^\([1-9]{2}\) [2-9][0-9]{3,4}\-[0-9]{4}$/

        FIELDS.forEach(campo => {
            newState[`${campo}Error`] = !this.state[campo]

            ['name', 'email', 'telephone', 'company', 'activeClients']
            switch (campo) {
                case 'email':
                    newState[`${campo}Error`] = !regexEmail.test(this.state[campo].toLowerCase())
                    break
                case 'name':
                    newState[`${campo}Error`] = !regexName.test(this.state[campo])
                    break
                case 'telephone':
                    newState[`${campo}Error`] = !regexTelephone.test(this.state[campo])
                    break
                case 'company':
                    newState[`${campo}Error`] = !this.state[campo].length > 0
                    break
                case 'activeClients':
                    newState[`${campo}Error`] = !this.state[campo].length > 0
                    break
            }
        })

        this.setState(newState)
        const lista = Object.values(newState)
        return lista.every(value => (!value))
    }

    telephoneMask(value) {
        var cleanTelephone = value ? value.replace(/\D/g, "") : '',
            numberLength = cleanTelephone.length

        if(numberLength > 10) {
            cleanTelephone = cleanTelephone.slice(0, 7) + '-' + cleanTelephone.slice(7)
        } else if(numberLength > 6 && numberLength < 11) {
            cleanTelephone = cleanTelephone.slice(0, 6) + '-' + cleanTelephone.slice(6)
        }

        if(numberLength > 2) {
            cleanTelephone = cleanTelephone.slice(0, 2) + ') ' + cleanTelephone.slice(2)
        }

        if(numberLength > 0) {
            cleanTelephone = '(' + cleanTelephone.slice(0)
        }

        return cleanTelephone
    }

    submitForm(e) {
        e.preventDefault()
        if (this.validation()) {
            const data = {
                conversion_identifier: 'solicitou-contato-parceiro',
                'cf_tipo_de_conversao': 'Solicitou Contato Parceiro',
                company_name: this.state.company,
                name: this.state.name,
                email: this.state.email,
                personal_phone: this.state.telephone,
                'cf_clientes_ativos_canais': this.state.activeClients,
                'cf_ramo_de_atuacao_canais': this.state.activity,
                'cf_percentual_perfil_ind_dist_canais': this.state.clients,
            }

            if(this.state.partnerId) {
                data['conversion_identifier'] = 'canais-lp',
                data['cf_codigo_do_parceiro_meus_pedidos'] = this.props.partnerId
            }

            this.rdGateway.sendToRDStation(data)

            this.setState({
                showDemoForm: false
            })

            setTimeout(() => {
                this.setState({
                    showDemoModal: false,
                    showDemoForm: true
                })
            }, 3000)
        }
    }

    componentDidMout() {
        this.setDataByCookie()
    }

    getDemoModal() {
        return (<Modal callbackCloseModal={() => this.closeDemoModal()}>
            <div className={cx('container-form-modal', this.state.showDemoForm ? '' : 'hide')}>
                <Heading4>Quer ser um Mpartner?</Heading4>
                <Paragraph>Deixe seu contato e venha conquistar mercados com a gente.</Paragraph>
                <form action='/' method='POST' className='form-rounded-inputs' onSubmit={e => this.submitForm(e)}>
                    <label htmlFor='name'>Nome</label>
                    <Input id='name' value={this.state.name} onChange={e => this.handleChange(e)} error={this.state.nameError} autoFocus/>

                    <label htmlFor='email'>E-mail</label>
                    <Input id='email' value={this.state.email} onChange={e => this.handleChange(e)} error={this.state.emailError}/>

                    <label htmlFor='telephone'>Telefone</label>
                    <Input id='telephone' value={this.state.telephone} onChange={e => this.handleChange(e)} error={this.state.telephoneError} maxLength='15'/>

                    <label htmlFor='company'>Empresa</label>
                    <Input id='company' value={this.state.company} onChange={e => this.handleChange(e)} error={this.state.companyError}/>

                    <label style={{
                            marginTop: '20px'
                        }}>Qual é o ramo de atuação da sua empresa?</label>
                    <div className={'group-buttons'}>
                        <Button model='outline' className={this.getSelectedActivity(ACTIVITY.erpSalesChannel)} onClick={() => this.handlerEnterpriseActivity(ACTIVITY.erpSalesChannel)}>Canal de vendas de ERP</Button>
                        <Button model='outline' className={this.getSelectedActivity(ACTIVITY.erpManufacturer)} onClick={() => this.handlerEnterpriseActivity(ACTIVITY.erpManufacturer)}>Fabricante - ERP</Button>
                        <Button model='outline' className={this.getSelectedActivity(ACTIVITY.integrator)} onClick={() => this.handlerEnterpriseActivity(ACTIVITY.integrator)}>Integrador</Button>
                    </div>

                    <label htmlFor='activeClients'>Quantos clientes ativos você possui?</label>
                    <Input id='activeClients' value={this.state.activeClients} onChange={e => this.handleChange(e)} error={this.state.activeClientsError}/>

                    <label style={{
                            marginTop: '20px'
                        }}>Quanto dos seus clientes correspondem a Indústria ou Distribuição?</label>
                    <div className={'group-buttons'}>
                        <Button model='outline' className={this.getSelectedClients(CLIENTS.zero)} onClick={() => this.handlerClients(CLIENTS.zero)}>0%</Button>
                        <Button model='outline' className={this.getSelectedClients(CLIENTS.upToTwenty)} onClick={() => this.handlerClients(CLIENTS.upToTwenty)}>Até 20%</Button>
                        <Button model='outline' className={this.getSelectedClients(CLIENTS.upToFifty)} onClick={() => this.handlerClients(CLIENTS.upToFifty)}>Até 50%</Button>
                        <Button model='outline' className={this.getSelectedClients(CLIENTS.upToEighty)} onClick={() => this.handlerClients(CLIENTS.upToEighty)}>Até 80%</Button>
                        <Button model='outline' className={this.getSelectedClients(CLIENTS.upToHundred)} onClick={() => this.handlerClients(CLIENTS.upToHundred)}>81% ou mais</Button>
                    </div>

                    <div className='submit-demo-modal'>
                        <Button type='submit' radius='half-rounded'>Solicitar contato</Button>
                    </div>
                </form>
            </div>
            <div className={cx('container-form-confirm', !this.state.showDemoForm ? '' : 'hide')}>
                <img className='success-icon' src='/images/success.png' alt='Solicitação enviada com sucesso!'/>
                <p className='paragraph'>Sua solicitação foi enviada com sucesso!</p>
            </div>
        </Modal>)
    }

    render() {
        let size = this.props.size,
            model = this.props.model

        return (
            <Fragment>
                <ButtonLink
                    href='#'
                    className={this.props.className}
                    onClick={e => this.openDemoModal(e)}
                    model={model}
                    size={size}
                    title='Peça um contato dos nossos especialistas.'
                    radius='half-rounded'>
                    Seja nosso parceiro
                </ButtonLink>
                {this.state.showDemoModal && this.getDemoModal()}
            </Fragment>
        )
    }
}

PartnerContactModal.propTypes = {
    className: PropTypes.string
}

export default PartnerContactModal



// WEBPACK FOOTER //
// /usr/src/site-blog/src/components/site/Partner/PartnerContactModal.jsx